import React from "react";
import "./styles/TransposApp.css";
import {GameStyleType} from "./Components/types/types"
import Board from "./Components/Board";
import TopBar from "./Components/TopBar";
import Helppanel from "./Components/Helppanel";
import { GameProvider } from "./GameContext";
import FullscreenToggle from "./FullscreenToggle";

const AppContent: React.FC<GameStyleType> = ({random,rounds,help}) => {
  return (
    <div id="transpos-content">
      <div className="transpos-conteiner">
        <div className="transpos-titleGame">
          <div className="transpos-mainsubtitle">Перестановочный шифр</div>
          <FullscreenToggle />
        </div>
        <div className="transpos-game-wrapper">
          <div className="transpos-Scene">
            <TopBar />
            <Board random ={random} rounds={rounds} help = {help}/>
          </div>
        </div>
        <Helppanel />
      </div>
    </div>
  );
};

const App: React.FC<GameStyleType> = (props) => {
  return (
    <GameProvider>
      <AppContent random ={props.random} rounds ={props.rounds} help={props.help}/>
    </GameProvider>
  );
};

export default App;
